import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';

export const YoureNotBehind = () => {
  return (
    <div className="min-h-[calc(100vh-64px)]" data-testid="chapter-youre-not-behind">
      <article className="max-w-2xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <header className="mb-16 animate-fade-in">
          <p className="text-xs font-sans font-medium tracking-widest uppercase text-stone-400 mb-4">
            Chapter
          </p>
          <h1 className="font-serif font-light text-3xl md:text-4xl lg:text-5xl text-stone-800 tracking-tight leading-[1.2]">
            You're Not Behind
          </h1>
        </header>

        <div className="prose-living space-y-8 animate-fade-in-delay-1">
          <p>
            There is no timeline you've missed. No schedule you've failed to keep.
          </p>

          <p>
            Whatever brought you here — curiosity, concern, a quiet nudge — 
            you arrived at the right moment. The moment you were ready.
          </p>

          <p>
            Life doesn't move in a straight line. Neither does preparation. 
            Some things get done early. Others wait until the time is right. 
            Both are valid.
          </p>

          <div className="py-8 border-t border-b border-stone-100 my-12">
            <p className="font-serif text-lg text-stone-700 italic">
              "Being behind" assumes there's a race.
              <br />
              This isn't a race.
              <br />
              This is care — taken at your own pace.
            </p>
          </div>

          <p>
            Whatever you haven't done yet doesn't define you. 
            Whatever you have done matters. 
            And whatever you do next — if you choose to do anything — 
            will be enough.
          </p>

          <p>
            You're not behind. You're here.
          </p>

          <p>
            That's where you start.
          </p>
        </div>

        <nav className="mt-16 pt-8 border-t border-stone-100 animate-fade-in-delay-2">
          <p className="text-sm font-sans text-stone-400 mb-4">Explore other chapters</p>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/living-book/chapters/stability"
              className="inline-flex items-center gap-2 px-4 py-2 bg-stone-100 hover:bg-stone-200 rounded-full text-sm font-sans text-stone-600 transition-colors"
              data-testid="chapter-link-stability"
            >
              <BookOpen className="w-4 h-4" strokeWidth={1.5} />
              Stability
            </Link>
            <Link
              to="/living-book/chapters/responsibility"
              className="inline-flex items-center gap-2 px-4 py-2 bg-stone-100 hover:bg-stone-200 rounded-full text-sm font-sans text-stone-600 transition-colors"
              data-testid="chapter-link-responsibility"
            >
              <BookOpen className="w-4 h-4" strokeWidth={1.5} />
              Responsibility
            </Link>
            <Link
              to="/living-book/chapters/legacy"
              className="inline-flex items-center gap-2 px-4 py-2 bg-stone-100 hover:bg-stone-200 rounded-full text-sm font-sans text-stone-600 transition-colors"
              data-testid="chapter-link-legacy"
            >
              <BookOpen className="w-4 h-4" strokeWidth={1.5} />
              Legacy
            </Link>
          </div>
        </nav>
      </article>
    </div>
  );
};

export default YoureNotBehind;
